import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTranslation } from '../translations/index.js';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Get language from localStorage or default to English
    return localStorage.getItem('language') || 'en';
  });

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  useEffect(() => {
    // Update HTML lang attribute
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  // Translation function
  const t = (key) => getTranslation(currentLanguage, key);

  const value = {
    currentLanguage,
    changeLanguage,
    isEnglish: currentLanguage === 'en',
    isMontenegrin: currentLanguage === 'me',
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};